import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

interface Props {
  className?: string;
  message?: string;
}

/**
 * Loading fallback component for React.lazy() Suspense boundaries.
 * Shows a centered spinner with optional loading message.
 */
const LoadingFallbackImpl: React.FC<Props> = ({
  className,
  message = 'Loading...',
}) => {
  return (
    <Box
      className={className}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="200px"
      gap={2}
    >
      <CircularProgress size={40} />
      <Typography variant="body2" color="textSecondary">
        {message}
      </Typography>
    </Box>
  );
};

export const LoadingFallback = muiStyled(LoadingFallbackImpl)(
  () => css`
    width: 100%;
    min-height: 50vh;
  `
);

export default LoadingFallback;
